




import { Component, Mixins } from 'vue-property-decorator'

// mixins
import NotifyMixin from '@/mixins/NotifyMixin'
import VKIDMixin from '@/mixins/VKIDMixin'
// store
import AuthModule from '@/store/modules/auth'
import ProfileModule from '@/store/modules/profile'
import MasterEducationModule from '@/store/modules/master/education'

@Component
export default class VKAuth extends Mixins(NotifyMixin, VKIDMixin) {
  private mounted() {
    if (this.payload) {
      AuthModule.setVKPayload(this.payload)
      this.patchVK().then(() => {
        ProfileModule.fetchInformation()
          .then(() => {
            this.$bus.$emit('socketUser')
            MasterEducationModule.fetchMasterGroups()
              .catch(this.notifyError)
          })
          .catch(this.notifyError)
          .finally(() => {
            this.$router.replace({ name: 'profile' })
              .then(() => {
                if (localStorage.getItem('syncQuestionList') && localStorage.getItem('syncQuestionList') !== '{}') {
                  this.$bus.$emit('isSaveProgress')
                }
              })
              .catch(() => {return})
          })
      })
        .catch(err => {
          this.notifyError(err)
          this.$router.replace({ name: 'profile', query: { error: 'true' } })
            .catch(() => {return})
        })
    }
  }
}
